import root from './_root';

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

export default Uint8Array;
